import { useContext } from 'react';
import {
    FileManagerConfigContext,
    CommonFileManagerStateContext,
    FileManagerConfigContextType,
    CommonFileManagerStateContextType
} from 'contexts/FileManagerContext';

// Hook to access global file manager config (falls back gracefully if context is not present)
export function useFileManagerConfig(): FileManagerConfigContextType | undefined {
    return useContext(FileManagerConfigContext);
}

// Hook to access internal states and callbacks of the CommonFileManager components
export function useFileManagerState(): CommonFileManagerStateContextType {
    const context = useContext(CommonFileManagerStateContext);
    if (!context) {
        throw new Error('useFileManagerState must be used within a CommonFileManagerStateProvider');
    }
    return context;
}
